import { FaCheckCircle } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
`;

export const ContainerCloseModal = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

export const CloserIcon = styled(FiX)`
  color: #707070;
  cursor: pointer;
`;

export const CheckIcon = styled(FaCheckCircle)`
  color: #1a1d39;
`;

export const Title = styled.div`
  font-size: 20px;
  color: #1a1d39;
  font-weight: 600;
  margin: 20px;
`;

export const CopyLink = styled.button`
  width: 300px;
  height: 35px;
  border-radius: 50px;
  background-color: transparent;
  border: none;
  border: 2px solid #e26126;
  color: #e26126;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    transition: all 100ms ease-in-out;
    color: #c9562b;
    border: 2px solid #c9562b;
  }
`;

export const GoToSimulator = styled.a`
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  border-radius: 50px;
  font-weight: 700;
  background-color: #e26126;
  border: none;
  color: #ffffff;
  cursor: pointer;
  margin: 15px 0;
  text-decoration: none;

  &:hover {
    transition: all 100ms ease-in-out;
    background-color: #c9562b;
  }
`;
